import { put, select } from 'typed-redux-saga';

import { countMetrika } from '../../../../helpers/metrika';
import { selectParticipantRenderState } from '../participant-list/selectors';
import { hideParticipantList, setPageIdx, showParticipantList } from '../participant-list/slice';
import { DTMF_COMMANDS } from './command-map';

export function* dtmfOpenParticipantListSaga() {
    countMetrika('dtmf', 'participant-list', 'open');
    yield* put(showParticipantList());
}

export function* dtmfCloseParticipantListSaga() {
    countMetrika('dtmf', 'participant-list', 'close');
    yield* put(hideParticipantList());
}

export function* dtmfParticipantListChangePageSaga(command: string) {
    if (command !== DTMF_COMMANDS.participantList.prevPage && command !== DTMF_COMMANDS.participantList.nextPage) {
        return;
    }

    const { currentPageIdx, totalPages } = yield* select(selectParticipantRenderState);
    const direction = command === DTMF_COMMANDS.participantList.prevPage ? -1 : 1;
    const nextPageIdx = currentPageIdx + direction;

    countMetrika('dtmf', 'participant-list', 'change-page');

    if (nextPageIdx >= 0 && nextPageIdx < totalPages) {
        yield* put(setPageIdx(nextPageIdx));
    }
}
